import axiosInstance from "./axiosInstance";

const adService = {
  /** @param {"web"|"mobile"|undefined} [platform] - omit for full { web, mobile } catalog */
  placements: async (platform) => {
    const url = platform
      ? `ads/placements?platform=${encodeURIComponent(platform)}`
      : "ads/placements";
    const response = await axiosInstance.get(url);
    return response.data;
  },

  list: async (params = {}) => {
    // Admin list view (includes placements and aggregated view/click stats).
    const query = new URLSearchParams();
    if (params.page) query.append("page", params.page);
    if (params.limit) query.append("limit", params.limit);
    if (params.search) query.append("search", params.search);
    if (params.screenName) query.append("screenName", params.screenName);
    if (params.platform) query.append("platform", params.platform);
    if (params.status) query.append("status", params.status);
    if (params.mediaType) query.append("mediaType", params.mediaType);
    if (params.displayCategory) query.append("displayCategory", params.displayCategory);
    const url = `ads/admin${query.toString() ? `?${query.toString()}` : ""}`;
    const response = await axiosInstance.get(url);
    return response.data;
  },

  uploadMedia: async (file) => {
    // Upload image/video to storage (S3 or configured backend storage).
    const formData = new FormData();
    formData.append("file", file);
    const response = await axiosInstance.post("ads/admin/upload-media", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
    return response.data;
  },

  create: async (payload) => {
    // Create a new ad with placements[] (multi-select) + media + CTA.
    const response = await axiosInstance.post("ads/admin", payload);
    return response.data;
  },

  update: async (id, payload) => {
    // Update existing ad; backend will re-check "max 5 active per placement" rule.
    const response = await axiosInstance.put(`ads/admin/${id}`, payload);
    return response.data;
  },

  remove: async (id) => {
    const response = await axiosInstance.delete(`ads/admin/${id}`);
    return response.data;
  },

  stats: async (id) => {
    // Per-ad analytics (views/clicks over time).
    const response = await axiosInstance.get(`ads/admin/${id}/stats`);
    return response.data;
  },

  placementReport: async (params = {}) => {
    const query = new URLSearchParams();
    if (params.platform) query.append("platform", params.platform);
    if (params.startDate) query.append("startDate", params.startDate);
    if (params.endDate) query.append("endDate", params.endDate);
    const url = `ads/admin/report/placements${query.toString() ? `?${query.toString()}` : ""}`;
    const response = await axiosInstance.get(url);
    return response.data;
  },
};

adService.getPlacements = adService.placements.bind(adService);
adService.getAds = adService.list.bind(adService);
adService.createAd = adService.create.bind(adService);
adService.updateAd = adService.update.bind(adService);
adService.deleteAd = adService.remove.bind(adService);

export default adService;

